'use client';

/**
 * USER DOCS: changes to this component should be accompanied by a
 * corresponding update to the user guide:
 * next_portal/user-docs/content/docs/total-attendance/dashboard-and-monitoring.mdx
 * (published at user-docs.totalaccess.co.za/total-attendance/dashboard-and-monitoring#security-violations)
 */

import dynamic from 'next/dynamic';

const LoadingFallback = () => (
  <div className="bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg h-64 flex items-center justify-center">
    <div className="flex flex-col items-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-3"></div>
      <p className="text-gray-500 dark:text-gray-400 text-sm">Loading map...</p>
    </div>
  </div>
);

const ViolationMapInner = dynamic(
  () => import('./ViolationMapInner'),
  { ssr: false, loading: () => <LoadingFallback /> }
);

export interface ViolationMapProps {
  latitude: number;
  longitude: number;
  expectedLatitude?: number | null;
  expectedLongitude?: number | null;
  expectedGeofenceName?: string;
  expectedGeofenceRadius?: number | null;
  accuracy?: number | null;
  employeeName?: string;
  violationType?: string;
  className?: string;
  /** Map height in px (default 320). Use ~140 for accordion thumbnails. */
  height?: number;
  /** Drop the rounded border wrapper (used when the map sits inside a card) */
  bare?: boolean;
}

const ViolationMap: React.FC<ViolationMapProps> = (props) => {
  return <ViolationMapInner {...props} />;
};

export default ViolationMap;
